package org.bsvac.bsvac_kmp.ui.models

import org.bsvac.bsvac_kmp.data.BsvacTextStyle
import org.bsvac.bsvac_kmp.data.models.AgencyModel
import org.bsvac.bsvac_kmp.data.models.AmbulanceUnitModel
import org.bsvac.bsvac_kmp.data.models.BoroughModel
import org.bsvac.bsvac_kmp.data.models.CrewModel
import org.bsvac.bsvac_kmp.data.models.RadioModel
import org.bsvac.bsvac_kmp.data.models.TourModel

data class LogonSubScreenModel(
    val bsvacTextStyle: BsvacTextStyle,
    val choices: Choices,
    val onSelection: OnSelection,
    val selected: Selected
)

data class Choices(
    val agencyOptions: List<AgencyModel>,
    val boroughOptions: List<BoroughModel>,
    val crewMemberOptions: List<CrewModel>,
    val unitOptions: List<AmbulanceUnitModel>,
    val tourOptions: List<TourModel>,
    val radioOptions: List<RadioModel>,
)

data class OnSelection (
    val onAgencySelected: (AgencyModel) -> Unit,
    val onCrewMemberSelected: (Int, CrewModel) -> Unit,
    val onBoroughSelected: (BoroughModel) -> Unit,
    val onAmbulanceUnitSelected: (AmbulanceUnitModel) -> Unit,
    val onTourSelected: (TourModel) -> Unit,
    val onRadioSelected: (Int, RadioModel) -> Unit,
)

data class Selected (
    val agency: AgencyModel? = null,
    val borough: BoroughModel? = null,
    val crewMember1: CrewModel? = null,
    val crewMember2: CrewModel? = null,
    val crewMember3: CrewModel? = null,
    val crewMember4: CrewModel? = null,

    val unit: AmbulanceUnitModel? = null,
    val tour: TourModel? = null,
    val radio1: RadioModel? = null,
    val radio2: RadioModel? = null,
    val radio3: RadioModel? = null,
    val radio4: RadioModel? = null,
)